import { MoreHorizRounded } from "@mui/icons-material";
import { Breadcrumbs, IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { ContextLabel } from "src/components";
import { ContextPathDto } from "src/http";

interface IProps {
  contextPath: ContextPathDto;
  linksOpenDrawer?: boolean;
}

const ContextPathBreadcrumbs = (props: IProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const breadcrumbs = getContextPathBreadcrumbs(props.contextPath);

  if (breadcrumbs.length <= 2) {
    return (
      <Breadcrumbs>
        {breadcrumbs.map((x, i) => (
          <ContextLabel
            context={x}
            hideTeamName
            key={i}
            openDrawerOnClick={props.linksOpenDrawer}
            sx={{ maxWidth: "190px" }}
          />
        ))}
      </Breadcrumbs>
    );
  } else {
    const firstBreadcrumb = breadcrumbs[0];
    const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];

    return (
      <>
        <Breadcrumbs>
          <ContextLabel
            context={firstBreadcrumb}
            hideTeamName
            openDrawerOnClick={props.linksOpenDrawer}
            sx={{ maxWidth: "190px" }}
          />
          <IconButton size="small" onClick={(event) => setAnchorEl(event.currentTarget)}>
            <MoreHorizRounded />
          </IconButton>
          <ContextLabel
            context={lastBreadcrumb}
            hideTeamName
            openDrawerOnClick={props.linksOpenDrawer}
            sx={{ maxWidth: "190px" }}
          />
        </Breadcrumbs>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
          {breadcrumbs.slice(1, -1).map((x, i) => (
            <MenuItem
              key={i}
              onClick={(e) => {
                setAnchorEl(null);
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <ContextLabel
                context={x}
                hideTeamName
                openDrawerOnClick={props.linksOpenDrawer}
                sx={{ maxWidth: "600px" }}
              />
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }
};

function getContextPathBreadcrumbs(parent: ContextPathDto) {
  const breadcrumbs: ContextPathDto[] = [];
  let current: ContextPathDto | undefined = parent;

  while (current) {
    breadcrumbs.push(current);
    current = current.parentContextItem;
  }

  return breadcrumbs.reverse();
}

export { ContextPathBreadcrumbs };
